export default __webpack_public_path__ + "static/media/jewel.9ff58672.jpg";